module.exports = __webpack_public_path__ + "img/icon-calendar.3cd7dc52.svg";